{
    "monster1": {
        "position": {
            "x": 15,
            "y": 5,
            "z": 1
        },
        "jobKey": "hammer",
        "affiliation": "bad",
        "key": "monster1",
        "isRemoved": true,
        "title": "???",
        "subtitle": "Monstrosity",
        "weaponAudioKey": "Unit:Attack:Monster",
        "previousMultiselect": {},
        "imageKey": "monster-arms-yellow",
        "maxhealth": "30"
    },
    "monster2": {
        "position": {
            "x": 15,
            "y": 6,
            "z": 1
        },
        "jobKey": "hammer",
        "affiliation": "bad",
        "key": "monster2",
        "isRemoved": true,
        "faceKey": "lich",
        "bodyKey": "imp",
        "title": "???",
        "weaponAudioKey": "Unit:Attack:Monster",
        "subtitle": "Monstrosity",
        "previousMultiselect": {},
        "imageKey": "monster-arms-yellow",
        "maxhealth": "30"
    },
    "artist": {
        "isRemoved": true,
        "position": {
            "x": 15,
            "y": 4,
            "z": 1
        },
        "subtitle": "Master of the Feast",
        "affiliation": "bad",
        "key": "artist",
        "maxhealth": 90,
        "previousMultiselect": {}
    },
    "Dspns2D8U0B5tuOILeIGH": {
        "position": {
            "x": 14,
            "y": 12,
            "z": 1
        },
        "jobKey": "sword",
        "affiliation": "bad",
        "key": "Dspns2D8U0B5tuOILeIGH",
        "faceKey": "lich",
        "bodyKey": "imp",
        "title": "???",
        "weaponAudioKey": "Unit:Attack:Monster",
        "subtitle": "Monstrosity",
        "maxhealth": "30",
        "previousMultiselect": {},
        "imageKey": "monster-tentacle-red"
    },
    "T1E_jC9vlM1RvRZOO_zMo": {
        "position": {
            "x": 18,
            "y": 14,
            "z": 1
        },
        "jobKey": "sword",
        "affiliation": "bad",
        "key": "T1E_jC9vlM1RvRZOO_zMo",
        "faceKey": "lich",
        "bodyKey": "imp",
        "title": "???",
        "weaponAudioKey": "Unit:Attack:Monster",
        "subtitle": "Monstrosity",
        "maxhealth": "30",
        "previousMultiselect": {},
        "imageKey": "monster-tentacle-red"
    },
    "occultist": {
        "position": {
            "x": 14,
            "y": 5,
            "z": 1
        },
        "templateKey": "player/feast/occultist",
        "key": "occultist",
        "previousMultiselect": [
            "occultist",
            "occultist",
            "professor",
            "professor",
            "priest",
            "priest"
        ]
    },
    "professor": {
        "position": {
            "x": 14,
            "y": 6,
            "z": 1
        },
        "templateKey": "player/feast/professor",
        "key": "professor",
        "previousMultiselect": [
            "occultist",
            "occultist",
            "professor",
            "professor",
            "priest",
            "priest"
        ]
    },
    "priest": {
        "position": {
            "x": 16,
            "y": 5,
            "z": 1
        },
        "templateKey": "player/feast/priest",
        "key": "priest",
        "previousMultiselect": [
            "occultist",
            "occultist",
            "professor",
            "professor",
            "priest",
            "priest"
        ]
    }
}